import { siteConfiguration } from "../../shared/sites/sites";

export default function ToggleSet() {
  const siblingSites = siteConfiguration.sibilingSites || [{ name: "", url: "" }];

  return (
    <div className="mb-10 border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] shadow-sm sm:rounded-lg">
      {siblingSites.map((site: any, index: any) => {
        return (
          <a
            key={site.name}
            href={site.url}
            className={`flex justify-center ${
              site.name === "AIPorn"
                ? "border-b-[0.5px] border-t-[0px] border-[#3C3C3C]"
                : index + 1 === siblingSites.length
                ? "border-t-[0.5px] border-[#3C3C3C]"
                : "border-b-[0.5px] border-t-[0.5px] border-[#3C3C3C]"
            } cursor-pointer py-4 text-sm font-bold text-[#3796F6]`}
          >
            {site.name}
          </a>
        );
      })}
    </div>
  );
}
